(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  document.addEventListener('toggle', event => {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.open || reduced.matches) return;
    if (!detail.closest('.sm-details, .product-accordions, .faq, .mobile-nav')) return;
    Array.from(detail.children).filter(node => node.tagName !== 'SUMMARY').forEach(node => {
      if (!node.animate) return;
      const animation = node.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.22,1,.36,1)' });
      animations.add(animation);
      animation.finished.catch(() => {}).finally(() => animations.delete(animation));
    });
  }, true);
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    animations.forEach(animation => animation.cancel());
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(node => node.classList.add('is-visible'));
    document.querySelectorAll('.sm-rise').forEach(node => node.classList.add('is-risen'));
  });
})();
